import TomSelect from "tom-select";
import "tom-select/dist/css/tom-select.default.css";

require("../../../../libraries/collapse");
// require("../../../global/policy-modal");

const Modal = require("../../../../libraries/Modal");

require("../../../modules/existing-customer")(TomSelect);
require("../../../modules/customer-verification")(TomSelect, Modal, {
	hasDevice: true
});
require("../../../modules/new-customer")(TomSelect);
require("../../../modules/registration-type-warning")(document);
// require("./parts/my-plan-submit");

(function() {

	axios.get("/my-plan/plan-data")
	.then(res => {

		const { infoCard, hasAddons, addonSelection } = res.data;
		const addonsWrapper = document.getElementById("additional-services");
		
		document.getElementById("info-card")
			.innerHTML = infoCard;

		addonsWrapper.innerHTML = addonSelection;

		if ( ! hasAddons ) {
			addonsWrapper.classList.add("hidden");
		}
		
		document.getElementById("terms-wrapper").classList.remove("hidden");

		require("./parts/my-plan");
		require("../../../modules/leave-page-warning");
		require("./parts/addon-functions");
		require("./parts/my-plan-submit");
	})
	.catch(err => {
		console.log(err);
	});

	axios.get("/my-plan/subscription-data")
	.then(res => {

		const { subscriptionTabs, isTranferedNumber } = res.data;

		document.getElementById("subscription-cnt").innerHTML = subscriptionTabs;

		if ( isTranferedNumber ) {
			const mobileNumberCnts = document.getElementsByClassName("js-customer-mobile-number-cnt");

			if (mobileNumberCnts != null) {
				
				for (let i = 0; i < mobileNumberCnts.length; i++) {
					mobileNumberCnts[i].classList.add("hidden");
				}
			}
		}

		require("./parts/number-tab-actions");
		require("./parts/get-new-number-functions")(TomSelect);
		require("./parts/keep-same-number-functions")(TomSelect);
	})
	.catch(err => {
		console.log(err);
	});

	axios.get("/my-plan/devices-data")
	.then(res => {

		const { deviceSelection, selectedDevice, hasDevice } = res.data;
		document.getElementById("devices-wrapper")
			.innerHTML = deviceSelection;

		document.getElementById("selected-device")
			.innerHTML = selectedDevice;

		if ( hasDevice ) {
			document.getElementById("device-selection-cnt").classList.add("hidden");
		}

		require("./parts/device-functions");
	})
	.catch(err => {
		console.log(err);
	});

	const policyModalElm = document.getElementById("policy-modal");
	const policyModal = new Modal({
		modal: policyModalElm,
		showBtns: document.getElementsByClassName("js-show-policy-btn")
	});
	
	axios.get("/mobile-documents")
		.then(res => {

			const { policyDescription, consentDescription } = res.data
			const consentCard = document.getElementById("consent-card");

			consentCard.classList.add("bg-white", "shadow-round");
			consentCard.innerHTML = consentDescription;

			document.getElementById("policy-docs")
				.innerHTML = policyDescription;
		})
		.catch(err => {
			console.log(err);
		})
})();